var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "app-collapse",
        { attrs: { title: "Área a ser permutada" } },
        [
          _c("app-display", {
            class:
              _vm.compararImovelPermuta &&
              _vm.compararImovelPermuta.mudouNumeroTitulo
                ? "text"
                : "",
            attrs: {
              label: "N° do título:",
              content: _vm.imovel.numeroTitulo,
              marginBottom: true
            }
          }),
          _vm.inputsExtraCadastro.imovel.nomeImovelPropriedade
            ? _c("app-display", {
                class:
                  _vm.compararImovelPermuta &&
                  _vm.compararImovelPermuta.mudouNomeImovelPropriedade
                    ? "text"
                    : "",
                attrs: {
                  label: "Nome do imóvel/Propriedade:",
                  content: _vm.imovel.nomeImovelPropriedade,
                  marginBottom: true
                }
              })
            : _vm._e(),
          _c("app-display", {
            class:
              _vm.compararImovelPermuta &&
              _vm.compararImovelPermuta.mudouCausasImpossibilidadeOcupacao
                ? "text"
                : "",
            attrs: {
              label: "Causas da impossibilidade de ocupação:",
              content: _vm.imovel.causasImpossibilidadeOcupacao
            }
          })
        ],
        1
      ),
      _c(
        "app-collapse",
        { attrs: { title: "Área de interesse" } },
        [
          _c("app-display", {
            class:
              _vm.compararImovelPermuta &&
              _vm.compararImovelPermuta.mudouNumeroReciboCar
                ? "text"
                : "",
            attrs: {
              label: "Número do recibo:",
              content: _vm.imovel.numeroReciboCar,
              marginBottom: true
            }
          }),
          _c("app-display", {
            class:
              _vm.compararImovelPermuta &&
              _vm.compararImovelPermuta.mudouTempoOcupacao
                ? "text"
                : "",
            attrs: {
              label: "Tempo de ocupação (em anos):",
              content: _vm.tempoOcupacaoFormatado,
              marginBottom: true
            }
          }),
          _c("app-display", {
            class:
              _vm.compararImovelPermuta &&
              _vm.compararImovelPermuta.mudouOcupantesAnteriores
                ? "text"
                : "",
            attrs: {
              label: "Há ocupantes anteriores?",
              content: _vm.imovel.ocupantesAnteriores ? "Sim" : "Não",
              marginBottom: true
            }
          }),
          _c("app-display", {
            class:
              _vm.compararImovelPermuta &&
              _vm.compararImovelPermuta.mudouPossuiImovel
                ? "text"
                : "",
            attrs: {
              label: "Possui outros imóveis rurais no " + _vm.ESTADO + "?",
              content: _vm.imovel.possuiImovel ? "Sim" : "Não",
              marginBottom: true
            }
          }),
          _c("app-display", {
            class:
              _vm.compararImovelPermuta &&
              _vm.compararImovelPermuta.mudouConflitos
                ? "text"
                : "",
            attrs: {
              label: "Há conflitos no imóvel?",
              content: _vm.imovel.conflitos ? "Sim" : "Não",
              marginBottom: true
            }
          }),
          _vm.imovel.conflitos
            ? _c("app-display", {
                class:
                  _vm.compararImovelPermuta &&
                  _vm.compararImovelPermuta.mudouNumeroProcessoJudicial
                    ? "text"
                    : "",
                attrs: {
                  label: "Nº do processo judicial:",
                  content: _vm.imovel.numeroProcessoJudicial
                }
              })
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5ebd30d7", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5ebd30d7","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/informacoesCadastro/cadastrosOnline/informacoesPermuta/InformacoesImovelPermuta.vue
// module id = null
// module chunks = 